/* eslint @typescript-eslint/no-explicit-any: "off" */

import env from "../../env"
import { RequestErrorDataApi } from "../../errors"

import {
    getJSON as getJSONBase,
    getText as getTextBase,
    postJSON as postJSONBase,
    remove as removeBase,
    patchJSON as patchJSONBase,
    putJSON as putJSONBase,
    postBody as postBodyBase,
} from "./base"

const apiPath = "dataapi"

export function getDataApiPathPrefix(): string {
    return `${env.applicationPath}/${apiPath}`
}

export function getJSON<T>(
    path: string,
    queryParameters?: any,
    receiver?: Api.Receiver,
): Promise<T> {
    return getJSONBase(
        `${apiPath}/${path}`,
        correctQueryParameters(queryParameters),
        new Headers(),
        receiver,
    )
}

export const getText = (
    path: string,
    queryParameters?: any,
    receiver?: Api.Receiver,
): Promise<string> =>
    getTextBase(
        `${apiPath}/${path}`,
        correctQueryParameters(queryParameters),
        new Headers(),
        receiver,
    )

export async function patchJSON<T>(
    path: string,
    args?: any,
    receiver?: Api.Receiver,
): Promise<T> {
    try {
        return patchJSONBase(
            `${apiPath}/${path}`,
            args,
            new Headers(),
            receiver,
        )
    } catch (error) {
        if (error instanceof Response) {
            const errorMessage = error instanceof Error ? error.message : ""
            throw await RequestErrorDataApi.create(
                errorMessage,
                error.status,
                error,
            )
        }
        throw error
    }
}

export function postJSON<T>(
    path: string,
    queryParameters?: any,
    receiver?: Api.Receiver,
): Promise<T> {
    return postJSONBase(
        `${apiPath}/${path}`,
        correctQueryParameters(queryParameters),
        new Headers(),
        receiver,
    )
}

export function putJSON(
    path: string,
    queryParameters?: any,
    receiver?: Api.Receiver,
): Promise<void> {
    return putJSONBase(
        `${apiPath}/${path}`,
        correctQueryParameters(queryParameters),
        new Headers(),
        receiver,
    )
}

export function postBody<T>({
    body,
    headers,
    path,
    queryParameters,
    receiver,
}: Api.RequestParametersWithBody): Promise<T> {
    return postBodyBase({
        args: correctQueryParameters(queryParameters),
        body: body,
        headers,
        path: `${apiPath}/${path}`,
        receiver,
    })
}

export function remove(
    path: string,
    queryParameters?: any,
    receiver?: Api.Receiver,
): Promise<void> {
    return removeBase(
        `${apiPath}/${path}`,
        correctQueryParameters(queryParameters),
        new Headers(),
        receiver,
    )
}

export const correctQueryParameters = (queryParameters?: any): any => {
    if (!queryParameters || !queryParameters.$filter) {
        return queryParameters
    }
    const containsRegexp = /contains\(.+?,'(.*?)'\)/g

    const containsQueries = []
    let match
    while ((match = containsRegexp.exec(queryParameters.$filter)) != null) {
        containsQueries.push(match)
    }

    if (containsQueries) {
        containsQueries.forEach((query: any) => {
            const initialFullQuery = query[0]
            const initialQueryValue = query[1]

            const correctedQueryValue = query[1].replace(/'/g, "''")
            const correctedFullQuery = initialFullQuery.replace(
                initialQueryValue,
                correctedQueryValue,
            )

            queryParameters.$filter = queryParameters.$filter.replace(
                initialFullQuery,
                correctedFullQuery,
            )
        })
    }

    return queryParameters
}
